<template>
  <ArticleDetail
    :article="article"
    :url-share="urlShare"
    :show-category="false"
    :show-button-save="false"
    :breadcrumbs="breadcrumbs"
    :share-networks="shareNetworks"
    :content-text-share="contentTextShare"
  />
</template>

<script setup>
import { STRUCTURED_DATA_TYPE } from '@/utils/enums';
import ArticleDetail from '@/components/Details/Article';

const { t } = useI18n();
const route = useRoute();
const store = useStore();
const { createHeadSeo } = useHeadSeo();
const urlShare = process.env.APP_BASE_DOMAIN + route.fullPath;

const { data: article } = await useAsyncData(
  `articleDetailNews_${route.params.slug}`,
  async () => await store.dispatch('strapi/getNewsBySlug', { slug: route.params.slug })
);

if (!Object.entries(article.value).length) throw showError({ statusCode: 404, fatal: true });

const breadcrumbs = computed(() => ({ path: NEWSROOMS_BASE_URL, section: t(`breadcrumbs.news`) }));
const shareNetworks = computed(() => store.getters['strapi/getByField']('common.social_sharing'));
const contentTextShare = computed(() =>
  store.getters['strapi/getByField']('common.social_sharing_modal')
);

const { meta_title: metaTitle, abstract, main_image: mainImage, og_image: ogImage } = article.value;
const imgUrl = ogImage?.url ?? mainImage?.url;

createHeadSeo(metaTitle, abstract, imgUrl, article.value, STRUCTURED_DATA_TYPE.NEWS);
</script>
